import React, { useMemo } from 'react';
import NavigationMenu from './components/NavigationMenu';
import { MODES } from './utils';
import { DEFAULT_LOCALE } from './services/localize';
import { type MenuTransformerProps, cmsConfigurationTransformer } from './transformer';
import { DEFAULT_CURRENCY } from './constants';
import type { Currency } from './types';
import './index.scss';

interface CategoriesMenuProps extends MenuTransformerProps {
    currency: Currency;
}

const CategoriesMenu = ({
    useCmsConfig = false,
    config = {},
    cmsConfig,
    mode = MODES.DEFAULT,
    locale = DEFAULT_LOCALE,
    theme,
    shouldPreRender = true,
    currency = DEFAULT_CURRENCY,
    rollouts = {},
}: CategoriesMenuProps) => {
    const transformedProps = useMemo(
        () =>
            cmsConfigurationTransformer({
                useCmsConfig,
                config,
                cmsConfig,
                mode,
                locale,
                theme,
                shouldPreRender,
                rollouts,
            }),
        [useCmsConfig, config, cmsConfig, mode, locale, theme, shouldPreRender, rollouts]
    );

    return <NavigationMenu {...transformedProps} currency={currency} />;
};

export default CategoriesMenu;
